// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ayepaulspqemtnvxrqgb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5ZXBhdWxzcHFlbXRudnhycWdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzEzNzQwNDIsImV4cCI6MjA0Njk1MDA0Mn0.LOmq6bse8rJX7yz61Uev7TMGPtr4xoq_7Chd8BHPRg0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
